import { Module } from 'vuex-smart-module';
import PollsActions from './actions';
import PollsGetters from './getters';
import PollsMutations from './mutations';
import PollsState from './state';

export default new Module({
  state: PollsState,
  mutations: PollsMutations,
  actions: PollsActions,
  getters: PollsGetters,
});
